import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'sort' })
export class SortPipe implements PipeTransform {
  public transform(data) {
    // data.sort((a, b) => a.localeCompare(b) );
    return data.sort((a, b) => a.value.trim().toLowerCase() > b.value.trim().toLowerCase() ? 1 : -1);
  }
}
